import { type FileDownloadOptions, useFileDownload } from "../../../hooks"
import { CommonExportButton } from "./CommonExportButton"

export const SingleExportButton = ({
  export: currentExport,
}: { export: FileDownloadOptions }) => {
  const { startDownload, isDownloading } = useFileDownload({
    name: currentExport.name,
    endpoint: currentExport.endpoint,
    extension: currentExport.extension,
  })

  return (
    <CommonExportButton
      title="Export"
      onClick={startDownload}
      loading={isDownloading}
    />
  )
}
